module.exports = __webpack_public_path__ + "img/header-image.c90872f.webp";